import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=48f0ad2a&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLink: require('/vercel/path0/components/general/ArrowLink.vue').default,SmallProductCard: require('/vercel/path0/components/cards/SmallProductCard.vue').default,MouseScroll: require('/vercel/path0/components/general/MouseScroll.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
